<div class="row content__grid">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box">
      <div class="row align-items-center">
        <div class="col-sm-6 col-md-6 col-sm-6 col-6">
          <!-- <h4 class="page-title content__title">Lista marcas</h4> -->
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i> Cuadres de agencia
          </a>
        </div>
        <div class="col-sm-6 col-sm-6 col-md-6 col-sm-6 col-6 content__boxBtnHead">
          <ng-container>
            <a routerLink="/{{branchofficeSlug}}/reportes/cuadresagencia/nuevo" class="btn btn-primary">
              <i class="fa fa-plus m-r-5"></i> Crear cuadre </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="card content__grid__card">
      <div class="card-body content__grid__cardbody">
        <div class="content__subhead">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-6 col-12 content__subhead__boxBtns">
              <button type="button" class="btn btn-light btn-sm" title="Actualizar" (click)="refresh()">
                <i class="fas fa-undo"></i></button>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-6 col-12">
              <component-search (searchEvent)="search($event)"></component-search>
            </div>
          </div>
        </div>
        <div class="content__boxTble">
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Código</th>
                  <th class="text-center">Agencia Viaje</th>
                  <th class="text-center">Balance Traspaso</th>
                  <th class="text-center">Balance Recibido</th>
                  <!-- <th class="text-center">Diferencia</th> -->
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="items.length == 0">
                  <td colspan="4"><span>No se encontraron registros</span></td>
                </ng-container>
                <ng-container *ngIf="items.length > 0">
                  <tr
                    *ngFor="let item of items | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let i = index">
                    <td>
                      <a class="grid__link" (click)="detail(item.id)"
                        style="color: purple !important; font-weight: bold;">
                        {{item.code}}
                      </a>
                      <p class="bold f-s-10 m-b-0">
                        Reg. : {{item.created_at | date: 'mediumDate'}}</p>
                    </td>
                    <td class="text-center">
                      {{item.tradename}}
                    </td>
                    <td class="text-center">
                      <span class="text-danger bold">{{toolsService.momeySol()}}{{item.balance_transfers}}</span>
                    </td>
                    <td class="text-center">
                      <span class="text-success bold">{{toolsService.momeySol()}}{{item.balance_receiveds}}</span>
                    </td>
                    <!-- <td class="text-center">
                      <ng-container *ngIf="item.balance_transfers > item.balance_receiveds">
                        <span class="badge badge-danger f-s-10">Diferencia negativa, pagar</span>
                        <div class="m-t-2">{{toolsService.momeySol()}}{{item.balance_transfers - item.balance_receiveds}}</div>
                      </ng-container>
                      <ng-container *ngIf="item.balance_transfers < item.balance_receiveds">
                        <span class="badge badge-success f-s-10">Diferencia positiva, cobrar</span>
                        <div class="m-t-2">{{toolsService.momeySol()}}{{item.balance_transfers - item.balance_receiveds}}</div>
                      </ng-container>
                    </td> -->
                    <td class="text-center">
                      <span *ngIf="!item.is_debt" class="badge badge-warning">No liquidado</span>
                      <span *ngIf="item.is_debt" class="badge badge-success">Liquidado</span>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 ">
          <div class="row content_pagination">
            <div class="col-lg-4">
              <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span> registros.</p>
            </div>
            <div class="text-right col-lg-8">
              <ng-container *ngIf="items.length > 0">
                <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
